import * as Types from '../actions/Tracking/TrackingActionTypes';

const initialState = [];

const trackingReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
    case Types.CREATE_TRACKING:
        console.log('called create tracking', payload);
        return [...state, payload];
    case Types.READ_TRACKING:
        console.log('called read tracking', payload);
        // if (payload.id === 0) return payload.trackings;
        return payload.trackings;
    case Types.UPDATE_TRACKING:
        console.log('called update tracking', payload);
        return state.map((tracking) =>
            tracking.trackingId === payload.trackingId ? payload : tracking
        );
    case Types.DELETE_TRACKING:
        console.log('in delete');
        return state.filter((tracking) => tracking.trackingId !== payload);
    default:
        return state;
    }
};

export default trackingReducer;
